module.exports = __webpack_public_path__ + "img/trip_18.5eda65ae.jpg";